import { login, forgotPassword, loginResponse, loginClear, AuthCheck } from "./action/Login"
import { getStatistics } from "./action/dashboard"
import { viewAllAndroidBoxes, getBoxesStatus, getPortals, clearPortalsResponse, getMasterVendorLookup, getVendorUserLookup, setFilters, setPages } from "./action/addEditBox"
import { viewAllAndroidBoxesGo, viewAllPortalsIptvGo} from "./action/boxManagmentGo"
import { getAllVendorUser, changeVendorUserFilters } from "./action/vendorUser"
import { getActivityLog, clearActivityLog} from "./action/activityLog"
import { getAndroidBoxesLookup, getAndroidBoxPortals, androidBoxPortalsResponse} from "./action/masterPortal"

export const actionsApi = {
    login, 
    loginResponse,
    forgotPassword,
    loginResponse, 
    loginClear, 
    AuthCheck, 
    //dashboard
    getStatistics,
    //addandroidbox 
    // getBoxStatistics,
    viewAllAndroidBoxes, 
    getBoxesStatus,
    getPortals,
    clearPortalsResponse,
    getMasterVendorLookup,
    getVendorUserLookup,
    setFilters,
    setPages,
    //boxManagementGo
    viewAllAndroidBoxesGo,
    viewAllPortalsIptvGo,
    //vendorUser
    getAllVendorUser, 
    changeVendorUserFilters,
    //activityLog
    getActivityLog,
    clearActivityLog,
    //masterPortal
    getAndroidBoxesLookup,
    getAndroidBoxPortals,
    androidBoxPortalsResponse
}
